<!-- my-loader.component.html -->
<div class="progress-loader" [hidden]="!(loading | async)">
	<div class="loading-spinner">
		<img src="../../../../../../assets/media/loading/ekomgroup_loading_org.svg" />
		<!-- <span class="loading-message">Please wait...</span> -->
	</div>
</div>
